import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PLATFORM_SRC = 'https://elfsightcdn.com/platform.js';
const APP_CLASS = 'elfsight-app-23e8f670-62d1-4eb1-b8c5-629d12fd858a';

const HIDDEN_PATHS = [
  '/authentication',
  '/forgot-password',
  '/reset-password',
  '/demo',
  '/integrations/microsoft/callback',
  '/integrations/google/callback',
];

const isHiddenPath = (pathname) => (
  HIDDEN_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))
);

const ElfsightWhatsApp = () => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const loggedIn = Boolean(user) && !loading;
  const visible = loggedIn && !isHiddenPath(pathname);

  useLayoutEffect(() => {
    document.documentElement.classList.toggle('hp-elfsight-hidden', !visible);
    return () => {
      document.documentElement.classList.remove('hp-elfsight-hidden');
    };
  }, [visible]);

  useEffect(() => {
    if (!visible) return undefined;
    if (document.querySelector(`script[src="${PLATFORM_SRC}"]`)) return undefined;

    const script = document.createElement('script');
    script.src = PLATFORM_SRC;
    script.async = true;
    document.body.appendChild(script);
    return undefined;
  }, [visible]);

  if (!loggedIn) return null;

  return <div className={APP_CLASS} data-elfsight-app-lazy />;
};

export default ElfsightWhatsApp;
